function DocumentMainView() {
  return (
    <div >    
        DucuemntViw페이지이다.    
    </div>
  );
}

export default DocumentMainView;